import PropTypes from "prop-types";
import { useRef, useState } from "react";
// import { useNavigate } from "react-router";
import useAuth from "hooks/useAuth";
// material-ui
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import Avatar from "components/@extended/Avatar";
// project-imports
import ProfileTab from "./ProfileTab";
import MainCard from "components/MainCard";
import Transitions from "components/@extended/Transitions";

// assets

// tab panel wrapper
function TabPanel({ children, value, index, ...other }) {
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`profile-tabpanel-${index}`}
      aria-labelledby={`profile-tab-${index}`}
      {...other}
      sx={{ p: 1 }}
    >
      {value === index && children}
    </Box>
  );
}

// function a11yProps(index) {
//   return {
//     id: `profile-tab-${index}`,
//     "aria-controls": `profile-tabpanel-${index}`,
//   };
// }

// ==============================|| HEADER CONTENT - PROFILE ||============================== //

export default function ProfilePage({
  admin,
  open: externalOpen,
  setOpen: setExternalOpen,
  userData,
  anchorRef: externalAnchorRef,
  downLG,
}) {
  const theme = useTheme();
  const { user } = useAuth();
  const internalAnchorRef = useRef(null);
  const buttonRef = useRef(null);
  const [internalOpen, setInternalOpen] = useState(false);

  // Use external state if provided, otherwise use internal state
  // For Popper anchor: use external if provided (points to ListItem), otherwise use internal (points to ButtonBase)
  const popperAnchorRef = externalAnchorRef || internalAnchorRef;
  // For ButtonBase ref: always use buttonRef when external anchor is provided, otherwise use internalAnchorRef
  const buttonAnchorRef = externalAnchorRef ? buttonRef : internalAnchorRef;
  const open = externalOpen !== undefined ? externalOpen : internalOpen;
  const setOpen = setExternalOpen || setInternalOpen;

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    // Check if click is inside the anchor element or button
    const anchorElement = popperAnchorRef.current;
    const buttonElement = buttonRef.current;
    if (
      (anchorElement && anchorElement.contains(event.target)) ||
      (buttonElement && buttonElement.contains(event.target))
    ) {
      return;
    }
    setOpen(false);
  };

  // const [value, setValue] = useState(0);

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };
  function stringAvatar(firstName, lastName) {
    if (!firstName || !lastName)
      return {
        sx: {
          bgcolor: "primary.100",
          fontWeight: 700,
          fontSize: 12,
        },
      };

    return {
      sx: {
        bgcolor: "primary.100",
        fontWeight: 700,
        fontSize: 12,
      },
      children: `${firstName[0]}${lastName[0]}`.toUpperCase(),
    };
  }

  return (
    <Box sx={{ flexShrink: 0, ml: 0.7 }}>
      <ButtonBase
        sx={{
          p: 0.25,
          borderRadius: 1,
          // "&:hover": {
          //   bgcolor:
          //     theme.palette.mode === ThemeMode.DARK
          //       ? "secondary.light"
          //       : "secondary.lighter",
          // },
          "&:focus-visible": {
            outline: `2px solid ${theme.palette.secondary.dark}`,
            outlineOffset: 2,
          },
        }}
        aria-label="open profile"
        ref={buttonAnchorRef}
        aria-controls={open ? "profile-grow" : undefined}
        aria-haspopup="true"
        onClick={(e) => {
          e.stopPropagation();
          handleToggle();
        }}
      >
        {downLG && (
          <Box sx={{ position: "relative", display: "inline-flex" }}>
            {/* FB-story ring */}
            {!user?.is_verified && (
              <Box
                sx={{
                  position: "absolute",
                  inset: -3,
                  borderRadius: "50%",
                  border: "2.5px solid #f5a623",
                  "@keyframes ringBreath": {
                    "0%, 100%": {
                      opacity: 0.5,
                      boxShadow: "0 0 4px 1px rgba(245,166,35,0.3)",
                    },
                    "50%": {
                      opacity: 1,
                      boxShadow: "0 0 8px 3px rgba(245,166,35,0.65)",
                    },
                  },
                  animation: "ringBreath 2.4s ease-in-out infinite",
                }}
              />
            )}
            <Avatar
              {...stringAvatar(userData?.first_name, userData?.last_name)}
              src={userData?.profile_image_url}
              sx={{ width: 35, height: 35, fontSize: 14 }}
            />
            {/* ! badge bottom-right */}
            {!user?.is_verified && (
              <Box
                sx={{
                  position: "absolute",
                  bottom: -2,
                  right: -2,
                  width: 13,
                  height: 13,
                  borderRadius: "50%",
                  bgcolor: "#f57c00",
                  border: "1.5px solid #fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "0.5rem",
                  fontWeight: 900,
                  color: "#fff",
                  lineHeight: 1,
                  "@keyframes breatheWarnSm": {
                    "0%, 100%": { opacity: 0.65, transform: "scale(0.97)" },
                    "50%": { opacity: 1, transform: "scale(1.04)" },
                  },
                  animation: "breatheWarnSm 2.4s ease-in-out infinite",
                }}
              >
                !
              </Box>
            )}
          </Box>
        )}
        {/* <ArrowDown2 style={{ fontSize: "0.625rem", color: "gray" }} /> */}
      </ButtonBase>
      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={popperAnchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [{ name: "offset", options: { offset: [0, 9] } }],
        }}
      >
        {({ TransitionProps }) => (
          <Transitions
            type="grow"
            position="top-right"
            in={open}
            {...TransitionProps}
          >
            <Paper
              sx={{
                boxShadow: theme.customShadows.z1,
                width: 260,
                minWidth: 100,
                maxWidth: 260,
                [theme.breakpoints.down("md")]: { maxWidth: 250 },
                borderRadius: 1,
              }}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard border={false} content={false}>
                  <ProfileTab admin={admin} onClose={() => setOpen(false)} />
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.number,
  index: PropTypes.number,
  other: PropTypes.any,
};
